import { baseHelper } from "lib/helpers";

class OrderHelper {
  /**
   * @desc To return orders csv data
   * @param orderLines array of orderlines
   *
   * @return csv data
   *
   */
  orderCSVData = (
    orderLines = [],
    settingResponse,
    isWholesalePriceVisible = false,
    isCsv = false,
    isPdf = false,
    isVendor = false,
    cms
  ) => {
    const settingData = settingResponse.export;

    const {
      createdAt,
      fulfillmentStatus,
      lineItemId,
      markupPrice,
      orderId,
      orderNumber,
      orderStatus,
      price,
      product,
      quantity,
      vendor,
      wholesalePrice,
      totalDiscount,
      trackingNumber,
    } = settingData || {};

    const tempOrderObjData = { price: (price && price.label) || cms("section.exportOrder.label.price") };

    if (isWholesalePriceVisible) {
      tempOrderObjData.wholesalePrice =
        (wholesalePrice && wholesalePrice.label) || cms("section.exportOrder.label.wholesaleprice");
    }

    const orderdata = {
      orderId: (orderId && orderId.label) || cms("section.exportOrder.label.orderid"),
      lineItemId: (lineItemId && lineItemId.label) || cms("section.exportOrder.label.lineitemid"),
      product: (product && product.label) || cms("section.exportOrder.label.product"),
      orderNumber: (orderNumber && orderNumber.label) || cms("section.exportOrder.label.ordernumber"),
      orderStatus: (orderStatus && orderStatus.label) || cms("section.exportOrder.label.orderstatus"),
      fulfillmentStatus:
        (fulfillmentStatus && fulfillmentStatus.label) || cms("section.exportOrder.label.fulfillmentstatus"),
      // vendor: (vendor && vendor.label) || "Vendor",
      quantity: (quantity && quantity.label) || cms("section.exportOrder.label.quantity"),
      ...tempOrderObjData,
      // price: (price && price.label) || "Price",
      // markupPrice: (markupPrice && markupPrice.label) || "Markup Price",
      createdAt: (createdAt && createdAt.label) || cms("section.exportOrder.label.createdat"),
      trackingNumber: (trackingNumber && trackingNumber.label) || cms("section.orderList.label.trackingNumber"),
    };

    if (!isVendor) {
      orderdata.markupPrice = (markupPrice && markupPrice.label) || cms("section.exportOrder.label.markupprice");
      orderdata.vendor = (vendor && vendor.label) || cms("section.exportOrder.label.vendor");
    }

    const updatedArray = [];
    if (settingData) {
      const notAllowedCsvKeys = Object.keys(settingData).filter((item) => {
        let hideArray;
        if (isCsv) {
          hideArray = settingData[item] && settingData[item].isHideCsv;
        }

        if (isPdf) {
          hideArray = settingData[item] && settingData[item].isHidePdf;
        }
        return hideArray;
      });

      notAllowedCsvKeys.map((key) => {
        updatedArray.push(orderdata[key]);
        return false;
      });
    }
    const tempData = [(price && price.label) || cms("section.exportOrder.label.price")];

    if (isWholesalePriceVisible) {
      tempData.push((wholesalePrice && wholesalePrice.label) || cms("section.exportOrder.label.wholesaleprice"));
    }

    const orderArray = [
      (orderId && orderId.label) || cms("section.exportOrder.label.orderid"),
      (lineItemId && lineItemId.label) || cms("section.exportOrder.label.lineitemid"),
      (product && product.label) || cms("section.exportOrder.label.product"),
      (orderNumber && orderNumber.label) || cms("section.exportOrder.label.ordernumber"),
      (orderStatus && orderStatus.label) || cms("section.exportOrder.label.orderstatus"),
      (fulfillmentStatus && fulfillmentStatus.label) || cms("section.exportOrder.label.fulfillmentstatus"),
      // (vendor && vendor.label) || "Vendor",
      (quantity && quantity.label) || cms("section.exportOrder.label.quantity"),
      // (price && price.label) || "Price",
      ...tempData,
      // (markupPrice && markupPrice.label) || "Markup Price",
      (createdAt && createdAt.label) || cms("section.exportOrder.label.createdat"),
      (trackingNumber && trackingNumber.label) || cms("section.orderList.label.trackingNumber"),
      !isVendor ? (totalDiscount && totalDiscount.label) || cms("section.exportOrder.label.discount") : "",
    ];

    if (!isVendor) {
      orderArray.pop();
      orderArray.push((markupPrice && markupPrice.label) || cms("section.exportOrder.label.markupprice"));
      orderArray.push((vendor && vendor.label) || cms("section.exportOrder.label.vendor"));
      // orderArray.push((trackingNumber && trackingNumber.label) || cms("section.orderList.label.trackingNumber"));
    }

    const removeIndex = [];

    updatedArray.map((arr) => {
      const index = orderArray.indexOf(arr);
      removeIndex.push(index);
      return false;
    });

    const differenceArray = orderArray.filter((item) => !updatedArray.includes(item));

    const newOrderArray = [];
    newOrderArray[0] = differenceArray;

    orderLines.forEach((item, idx) => {
      const tempOrderData = [`${item.moneyFormat} ${baseHelper.formatPrice(item.price * item.quantity || 0)}`];

      if (isWholesalePriceVisible) {
        tempOrderData.push(
          `${item.moneyFormat} ${baseHelper.formatPrice(
            (isVendor ? item.vendorWholesalePrice : item.wholesalePrice) || 0
          )}`
        );
      }
      const roleBaseData = isVendor
        ? ""
        : [`${item.moneyFormat} ${item.markUpPrice}`, `${(item && item.vendor) || ""}`];
      newOrderArray[idx + 1] = [
        `${item.shopifyOrderId}`,
        `${item.shopifyLineItemId}`,
        item.name,
        `#${item.orderNumber}`,
        item.status,
        item.fulfillmentStatus,
        item.quantity,
        ...tempOrderData,
        baseHelper.formatDate(item.createdAt),
        item.trackingNumber,
        ...roleBaseData,
      ].filter((value, index) => {
        return removeIndex.indexOf(index) === -1;
      });
    });
    return newOrderArray;
  };
}

export default new OrderHelper();
